<script setup>
import {computed, defineEmits, defineProps, onMounted} from "vue";
import store from "@/store";
import {siteConfig} from "@/utils/config";

const type = computed(() => store.state.coupon)
const product = computed(()=>{
  if(type.value && siteConfig[type.value]){
    return siteConfig[type.value].components.product.view
  }
  return ""
})
const emit = defineEmits(['pay', 'login'])
const prop = defineProps(['showProduct', 'showOrder'])

// const productLst = ref([])
const account = computed(() => store.state.account)

onMounted(() => {
  store.commit("getCoupon")
  // getPro()
})

const login = ({product}) => {
  emit("login", {type: "login", product})
}
const seletedPro = ({product}) => {
  emit("pay", {type: "pay", product})
}
</script>

<template>
  <component :is="product" @login="login" @select-product="seletedPro" :show-order="prop.showOrder" :show-product="prop.showProduct"/>
</template>

<style scoped lang="less">

</style>
